/* Mid-page #buy-box anchors send the shopper down to the bundle selector.

   This used to also match `.sticky-add-to-cart__button` unconditionally, and it is
   loaded on every product template - so the sticky bar scrolled instead of adding on
   all of them, not just the landing one. Worse, it killed the click with
   stopImmediatePropagation, so no other handler (the theme's add-to-cart, or the
   gift/upsell routing in bundle-selector.js) ever got a look at it. The sticky bar
   now adds the current selection, so it must be left alone here; only an explicit
   [data-scroll-to-buybox] opts an element into scrolling.

   The theme scrolls inside .page-wrapper (html/body are overflow:hidden), so
   window.scrollTo is a no-op here. scrollIntoView walks to whatever the real
   scrolling ancestor is, and scroll-margin-top keeps the sticky header clear. */

const TARGETS = ['bundle-selector', '[data-bundle-cta]', '.product-details'];

function buyBox() {
  for (const sel of TARGETS) {
    const el = document.querySelector(sel);
    if (el) return el;
  }
  return null;
}

function headerOffset() {
  const header = document.querySelector('#header-component, .header-section, header');
  return (header ? header.getBoundingClientRect().height : 0) + 16;
}

function scrollToBuyBox() {
  const el = buyBox();
  if (!el) return false;
  el.style.scrollMarginTop = `${headerOffset()}px`;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });

  const focusable = el.querySelector('input, button, [tabindex]');
  if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 600);
  return true;
}

document.addEventListener(
  'click',
  (event) => {
    const anchor = event.target.closest('a[href="#buy-box"], a[href$="#buy-box"]');
    const optedIn = event.target.closest('[data-scroll-to-buybox]');
    if (!anchor && !optedIn) return;
    if (scrollToBuyBox()) {
      event.preventDefault();
      // stopImmediatePropagation also blocks handlers bound to the same element,
      // which a plain stopPropagation leaves running.
      event.stopImmediatePropagation();
      event.stopPropagation();
    }
  },
  true // capture, so the theme's add-to-cart handler never fires
);


/* A scroll-only button inside the product form must not submit it. Scoped to the
   opt-in attribute for the same reason as the click handler above - an unscoped
   match here would swallow a real add-to-cart submit from the sticky bar. */
document.addEventListener(
  'submit',
  (event) => {
    if (event.target.closest('sticky-add-to-cart:has([data-scroll-to-buybox])')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToBuyBox();
    }
  },
  true
);
